<template>
  <el-dialog class="pc-dialog pc-dialog__add-wizard"
    title="添加向导"
    :visible.sync="visible"
    width="40rem"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="closeHandler"
    >
    <div class="type">
      <el-radio-group v-model="type" size="small">
        <el-radio-button label="NOTE">笔记</el-radio-button>
        <el-radio-button label="NOTEBOOK">笔记本</el-radio-button>
      </el-radio-group>
    </div>
    <div class="name">
      <el-input :class="{'pc-is-error':invalid}" v-model="name" :placeholder="placeholder" size="small" @input="validateHandler"
        @keyup.native.enter="okHandler" ref="nameInput"/>
    </div>
    <span slot="footer" class="dialog-footer">
      <span class="pc-color-error" v-show="invalid">{{errorMessage}}</span>
      <el-button type="primary" size="small" @click="okHandler" :disabled="waiting">{{okButtonText}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { isNullOrWhiteSpace } from '@/common/utils'
import { operateError } from '@/common/errors'
import noteApi from '@/api/note'
import notebookApi from '@/api/notebook'

export default {
  data () {
    return {
      type: 'NOTE',
      name: '',
      invalid: false,
      waiting: false
    }
  },
  computed: {
    ...mapGetters('dialog', {
      addWizardVisible: 'addWizardVisible'
    }),
    visible: {
      get () {
        return this.addWizardVisible
      },
      set (value) {
        this.setAddWizardVisible(value)
      }
    },
    placeholder () {
      return this.type === 'NOTE' ? '请输入笔记名称' : '请输入笔记本名称'
    },
    okButtonText () {
      let text = this.type === 'NOTE' ? '创建笔记' : '创建笔记本'
      if (this.waiting) {
        text += ' ...'
      }
      return text
    },
    errorMessage () {
      return this.type === 'NOTE' ? '笔记名称不能为空' : '笔记本名称不能为空'
    }
  },
  methods: {
    ...mapMutations('dialog', {
      setAddWizardVisible: 'SET_ADD_WIZARD_VISIBLE'
    }),
    closeHandler () {
      this.name = ''
      this.type = 'NOTE'
      this.invalid = false
      this.waiting = false
    },
    validateHandler () {
      if (isNullOrWhiteSpace(this.name)) {
        this.invalid = true
      } else {
        this.invalid = false
      }
    },
    okHandler () {
      this.validateHandler()
      if (this.invalid) {
        return
      }
      if (this.type === 'NOTE') {
        this.createNote()
      } else if (this.type === 'NOTEBOOK') {
        this.createNotebook()
      }
    },
    async createNote () {
      const data = {
        name: this.name
      }
      this.waiting = true
      try {
        const result = await noteApi.add(data)
        const id = result.id
        this.setAddWizardVisible(false)
        this.$router.push({
          name: 'workbenchNote',
          params: {
            noteId: id
          }
        })
      } catch (e) {
        console.dir(e)
        operateError(e, '添加笔记')
      } finally {
        this.waiting = false
      }
    },
    async createNotebook () {
      const data = {
        name: this.name
      }
      this.waiting = true
      try {
        const result = await notebookApi.add(data)
        const id = result.id
        this.setAddWizardVisible(false)
        this.$router.push({
          name: 'workbenchNotebook',
          params: {
            notebookId: id
          }
        })
      } catch (e) {
        console.dir(e)
        operateError(e, '添加笔记本')
      } finally {
        this.waiting = false
      }
    }
  },
  watch: {
    addWizardVisible (newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.$refs.nameInput.focus()
        })
      }
    },
    type () {
      this.$refs.nameInput.focus()
    }
  }
}
</script>

<style lang="scss">
.pc-dialog__add-wizard {
  .type {
    text-align: center;
    margin-bottom: 2rem;
  }

  .pc-color-error {
    margin-right: 1rem;
  }

  .el-input__inner {
    font-size: 1.2rem;
  }
}
</style>
